import api from 'api'

export const fetchMe = async () => {
  const { data } = await api.get('/me')

  return data
}
